import { FlagStatus } from '@modules/HappinessModule/enums/FlagStatus';

export const mapFlagStatus = {
  [FlagStatus.Positive]: 'Resolved: Positive',
  [FlagStatus.Negative]: 'Resolved: Negative',
  [FlagStatus.InProgress]: 'In progress',
  [FlagStatus.OnHold]: 'On hold',
};
